import { render, staticRenderFns } from "./NoItems.vue?vue&type=template&id=43ed6abb&"
import script from "./NoItems.vue?vue&type=script&lang=ts&"
export * from "./NoItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports